<template>
  <div>
    <span v-for="item in data" :key="item.id">
      <div class="showImg">
        <img :src="config.urlImg + item.mediaPath" />
        <div class="open">
          <div>
            <span @click="showModal(item)">
              <img src="../images/eye.png" />
            </span>
            <!-- <span @click="deleteImg(item)">
              <img src="../../../../assets/image/garbage.png" />
            </span> -->
            <span @click="down(item)">
              <img src="../images/download1.png" />
            </span>
          </div>
        </div>
      </div>
    </span>
    <a-modal
      title="查看"
      :visible="visible"
      @ok="handleCancel"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
      :maskClosable="false"
      :destroyOnClose="true"
      wrapClassName="uploadImg"
      width="60%"
    >
      <template slot="footer">
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleCancel"
        >
          Confirm
        </a-button>
      </template>
      <div class="imgModalCon">
        <img :src="config.urlImg + nowImgPath" />
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  name: 'showImg',
  data() {
    return {
      nowImg: null,
      nowImgPath: null,
      loading: false,
      visible: false,
      confirmLoading: false,
    };
  },
  props: {
    data: Array,
    otherData: Object,
    id: String,
  },
  computed: {
    fabricDetails: {
      get() {
        return this.$store.state.report.fabricDetails;
      },
      set(val) {
        this.$store.commit('report/save', { fabricDetails: val });
      },
    },
  },
  methods: {
    uploadChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        if (info.file.response.data) {
          this.$message.success('上传成功，保存后生效');
          this.loading = false;
          this.data.push(info.file.response.data.object);
        } else {
          this.$$message.error('上传失败');
        }
      }
    },
    //编辑图片
    showModal(value) {
      this.visible = true;
      this.nowImg = value;
      this.nowImgPath = value.mediaPath;
    },
    handleOk() {
      // 输出
      this.confirmLoading = true;
      this.$refs.cropper.getCropBlob(data => {
        let formdata = new FormData();
        formdata.append('file', data);
        formdata.append('mediaName', this.otherData.mediaName);
        formdata.append('mediaType', this.otherData.mediaType);
        formdata.append('personId', this.otherData.personId);
        formdata.append('orderId', this.otherData.orderId);
        formdata.append('reportId', this.otherData.reportId);
        formdata.append('mediaDesc', this.otherData.mediaDesc);
        this.$http
          .post('/hzwmj/media/fileUpload', formdata)
          .then(data => {
            if (data) {
              this.data.forEach((item, index) => {
                if (item.id == this.nowImg.id) {
                  this.data.splice(index, 1, data.object);
                }
              });
              this.$http.post('/hzwmj/media/delete', {
                id: this.nowImg.id,
              });
              this.confirmLoading = false;
              this.$message.success('裁剪成功，保存后生效');
              this.visible = false;
            } else {
              this.$message.error('裁剪失败');
              this.confirmLoading = false;
            }
          })
          .catch(() => {
            this.$message.error('裁剪失败');
            this.confirmLoading = false;
          });
      });
    },
    handleCancel() {
      this.visible = false;
    },
    //删除图片
    deleteImg(value) {
      this.$confirm({
        title: '提示',
        content: '是否确认删除此照片',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          this.$http
            .post('/hzwmj/media/delete', {
              id: value.id,
            })
            .then(data => {
              if (data) {
                this.$message.success('删除成功');
                this.data.forEach((item, index) => {
                  if (item.id == value.id) {
                    this.data.splice(index, 1);
                  }
                });
                this.$store.dispatch(
                  'report/getfabricImg',
                  this.fabricDetails.freportId,
                );
              } else {
                this.$message.error('删除失败');
              }
            })
            .catch(() => {
              this.$message.error('删除失败');
            });
        },
        onCancel: () => {
          console.log('Cancel');
        },
      });
    },
    down(value) {
      let aLink = document.createElement('a');
      aLink.download = value.mediaName;
      aLink.target = '_blank';
      document.body.appendChild(aLink);
      aLink.href = this.config.urlImg + value.mediaPath;
      aLink.click();
      aLink.remove();
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
  },
};
</script>
<style lang="less">
.showImg {
  display: inline-block;
  width: 160px;
  height: 120px;
  border: 1px solid rgb(202, 202, 202);
  text-align: center;
  margin: 10px;
  overflow: hidden;
  position: relative;
  > img {
    max-width: 100%;
    max-height: 100%;
  }
  &:hover .open {
    display: block;
  }
  .open {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    > div {
      display: flex;
      height: 120px;
      align-items: center;
      justify-content: center;
      span {
        width: 24px;
        height: 24px;
        display: inline-block;
        cursor: pointer;
        margin: 0 4px;
        img {
          width: 100%;
        }
      }
    }
  }
}
.proImg {
  display: inline-block;
  width: 160px;
  height: 120px;
  border: 1px solid rgb(202, 202, 202);
  text-align: center;
  margin: 10px;
  overflow: hidden;
  > img {
    max-width: 100%;
    max-height: 100%;
  }
}
.upload {
  border: none;
  .ant-upload.ant-upload-select-picture-card {
    width: 160px;
    height: 120px;
    margin: 0;
  }
}
.uploadImg {
  .imgModalCon {
    width: 480px;
    height: 360px;
    margin: 0 auto;
    text-align: center;
    border: 1px solid rgb(202, 202, 202);
    overflow: hidden;
    position: relative;
    > img {
      // width: 100%;
      max-width: 100%;
      max-height: 100%;
    }
    .change {
      width: 48px;
      height: 48px;
      background-color: rgba(255, 255, 255);
      cursor: pointer;
      position: absolute;
      bottom: 0;
      left: 210px;
    }
  }
  .imgAction {
    display: flex;
    width: 100px;
    margin: 10px auto 0;
    justify-content: space-between;
    span {
      width: 32px;
      height: 32px;
      display: inline-block;
      cursor: pointer;
      > img {
        width: 100%;
      }
    }
  }
}
</style>
